module.exports = __webpack_public_path__ + "static/img/ps_shop.14027386.png";